import type { AreaCatalog } from '../area';
import type { create as en } from '../en/create';

export const create = {
  'create.error.unreachable': 'Der Server ist nicht erreichbar. Bitte versuch es noch einmal.',
  'create.task.label': 'Neue Aufgabe',
  'create.task.placeholder': 'Aufgabe hinzufügen',
  'create.task.add': 'Hinzufügen',
  'create.task.retry': 'Nicht gespeichert. Erneut versuchen',
  'create.task.failed': '{title}: {retry}',
  'create.task.unmatched': '{title} ist nicht in dieser Liste.',
  'create.addBar.placeholder': 'Hier hinzufügen oder erstellen…',
  'create.addBar.label': 'Aufgabe auf diesem Board hinzufügen oder erstellen',
  'create.addBar.add': 'Hinzufügen',
  'create.addBar.results': 'Hinzufügen oder erstellen',
  'create.addBar.mutedTitle':
    'Du siehst diese Aufgabe, aber um sie hier hinzuzufügen, brauchst du Zugriff als Verwaltende.',
  'create.addBar.cantAdd': 'hier nicht möglich',
  'create.addBar.addHint': 'hinzufügen',
  'create.addBar.createRow': '{title} als neue Aufgabe erstellen',
  'create.addBar.quoted': '„{text}“',
  'create.addBar.newHint': 'neu',
  'create.addBar.flowForbidden':
    'Hinzugefügt, aber nicht in den Ablauf dieses Boards aufgenommen: Du darfst die Aufgabe nicht bearbeiten.',
  'create.addBar.flowRefused':
    'Hinzugefügt, aber nicht in den Ablauf dieses Boards aufgenommen: Der Ablauf hat die Aufnahme abgelehnt.',
  'create.view.titleLens': 'Neue Ansicht',
  'create.view.titleView': 'Neues Board',
  'create.view.cancel': 'Abbrechen',
  'create.view.createLens': 'Ansicht erstellen',
  'create.view.createBoard': 'Board erstellen',
  'create.view.kind': 'Art',
  'create.view.kindLabel': 'Ansicht oder Board',
  'create.view.lens': 'Ansicht',
  'create.view.view': 'Board',
  'create.view.hintLens':
    'Eine gespeicherte Art hinzusehen. Sie zeigt jeder Person, was sie ohnehin sehen darf.',
  'create.view.hintView':
    'Enthält die Aufgaben, die du darauf legst. Alle auf dem Board sehen dieselben Aufgaben und können daran arbeiten.',
  'create.view.name': 'Name',
  'create.view.namePlaceholderLens': 'Name der Ansicht',
  'create.view.namePlaceholderView': 'Name des Boards',
  'create.view.nameLabelLens': 'Name der neuen Ansicht',
  'create.view.nameLabelView': 'Name des neuen Boards',
  'create.view.nameMissingLens': 'Gib der Ansicht einen Namen.',
  'create.view.nameMissingView': 'Gib dem Board einen Namen.',
  'create.group.trigger': 'Neue Gruppe',
  'create.group.placeholder': 'Name der Gruppe',
  'create.group.label': 'Name der neuen Gruppe',
  'create.error.titleNeeded': 'Eine Aufgabe braucht einen Titel.',
  'create.error.titleBesidesTags': 'Eine Aufgabe braucht einen Titel neben ihren Tags.',
  'create.error.groupNameNeeded': 'Eine Gruppe braucht einen Namen.',
} as const satisfies AreaCatalog<typeof en>;
